<template>
    <div>
        <table class="table table-striped">
            <tbody>
            <tr>
                <td>Debiterbara timmar</td>
                <td class="text-right">{{calculationData.ChargableHours}}</td>
            </tr>
            <tr>
                <td>Debiterade timmar</td>
                <td class="text-right">{{calculationData.ChargedHours}}</td>
            </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td><strong>Summa</strong></td>
                    <td class="text-right"><strong>{{calculationData.Sum}}</strong></td>
                </tr>
            </tfoot>

        </table>
    </div>
</template>

<script>
export default {
  props: {
    calculationData: Object
  }
}
</script>

<style>

</style>
